<ng-doc-root>
  <ng-doc-navbar>
    <h3 routerLink="" ngDocNavbarLeft>M-theme/M-ui</h3>
    <m-theme-toggle [mode]="THEME_MODE.LITE" ngDocNavbarRight></m-theme-toggle>
  </ng-doc-navbar>
  <ng-doc-sidebar></ng-doc-sidebar>
  <router-outlet></router-outlet>
</ng-doc-root>
